<div class="bg-surface-tile text-white">
  <div class="px-4 py-3 text-md font-normal tracking-widest uppercase">Research</div>
  <div class="px-4 py-4">
    @if (!researchOverviewList()[0]?.hide_pdf) {
      <div class="text-center mb-4">
        <a
          href="{{ researchOverviewList()[0]?.pdf?.downloadURL }}"
          reportId="company-research-latest"
          target="_blank"
          trackDownload>
          <button class="bg-brand-500 hover:bg-brand-600 py-2 px-4 uppercase tracking-widest">
            Download the Latest Research
          </button>
        </a>
      </div>
    }

    <div class="grid grid-cols-5 gap-2 py-4">
      <div class="col-span-1">Release date</div>
      <div class="col-span-3">Title</div>
      <div class="col-span-1"></div>
    </div>

    <hr class="w-full border-border" />
    <div class="divide-y divide-gray-200 overflow-y-auto max-h-96">
      @for (item of researchOverviewList(); track item; let index = $index) {
        <a
          class="grid grid-cols-5 gap-2 py-2 hover:underline"
          href="{{ item?.pdf?.downloadURL }}"
          reportId="company-research"
          target="_blank"
          trackDownload>
          <div class="col-span-1 flex items-center">
            <!-- ui-store-migrate (Phase 2 codemod): <app-date [date] [formatType]=...> → <app-ui-date-display [value] format=...> ; app-ui-date-display adds null/fallback handling. -->
            <app-date [date]="item.published_date" [formatType]="'dd.MM.yyyy'"></app-date>
          </div>
          <div class="col-span-3 font-normal flex items-center">
            {{ item.title }}
          </div>
          <div class="col-span-1 text-right">
            @if (!item.hide_pdf) {
              <app-button-download-pdf
                [buttonClasses]="
                  'bg-transparent hover:bg-gray-300 font-normal py-2 px-4 rounded-sm uppercase tracking-widest hover:cursor-pointer'
                "
                [pdf]="item.pdf"></app-button-download-pdf>
            }
          </div>
        </a>
      }
    </div>
  </div>
</div>
